import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  duration,
  easing,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = css`
  ${breakpoint.up('smMd')} {
    max-width: ${width.container.wide};
    margin: 0 auto;
  }
`

export const title = css`
  margin: ${size[48]} 0 ${size[32]};
  padding: 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(40)};
    margin: ${size[64]} 0;
    padding: 0;
  }
`

export const list = css`
  margin: 0;
  padding: 0 ${size[20]};
  display: flex;
  flex-direction: column;
  gap: ${size[20]};

  ${breakpoint.up('smMd')} {
    padding: 0;
  }
`

export const file = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${size[12]};

  svg {
    path {
      fill: ${theme.palette.primary.mainContrast};
    }
  }
`

export const link = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${size[8]};

  color: ${theme.palette.primary.mainContrast};
  font-size: ${pxToRem(18)};
  font-weight: 500;
  text-decoration: none;

  ${breakpoint.up('smMd')} {
    display: inline;
    font-size: ${fontSize.xs};

    span {
      transition: all ${duration.gentle}ms ${easing.easeInOut};
    }

    &:hover > span {
      color: ${theme.palette.primary.mainContrast};
      text-decoration: underline;
      transition: all ${duration.gentle}ms ${easing.easeInOut};
    }
  }
`

export const name = css`
  max-width: 80%;
`

export const details = (theme: Theme) => css`
  color: ${theme.palette.text.body};
  align-self: flex-end;
  font-size: ${fontSize.xxs};
  white-space: nowrap;

  ${breakpoint.up('smMd')} {
    color: ${theme.palette.primary.mainContrast};
    font-size: ${fontSize.xs};
  }
`
